import React, { useRef } from "react";
import { View, Text, Image } from "react-native";
import { Marker } from "react-native-maps";

interface MarkerProps {
  marker: {
    cx_lat: string;
    cx_lng: string;
    user_name: string;
    source: any;
  };
  zoomLevel: number;
  handleMarkerPress: (marker: any) => void;
}

const MarkerLabel = ({
  user_name,
  zoomLevel,
}: {
  user_name: string;
  zoomLevel: number;
}) => {
  return zoomLevel > 14 ? <Text>{user_name}</Text> : null;
};

const MarkerImage = ({
  source,
  onLoadEnd,
}: {
  source: any;
  onLoadEnd: () => void;
}) => {
  return (
    <Image
      onLoadEnd={onLoadEnd}
      fadeDuration={0}
      source={source}
      style={{ height: 25, width: 25 }}
      resizeMode="contain"
    />
  );
};

const CustomMarker = React.memo(
  ({ marker, zoomLevel, handleMarkerPress }: MarkerProps) => {
    const { cx_lat, cx_lng, user_name, source } = marker;
    const markerRef = useRef<any>(null);

    const doRedraw = () => {
      markerRef.current?.redraw();
    };

    return (
      <Marker
        ref={markerRef}
        tracksInfoWindowChanges={false}
        tracksViewChanges={false}
        coordinate={{
          latitude: parseFloat(cx_lat),
          longitude: parseFloat(cx_lng),
        }}
        onPress={() => handleMarkerPress(marker)}
      >
        <View style={{ alignItems: "center" }}>
          <MarkerLabel user_name={user_name} zoomLevel={zoomLevel} />
          <MarkerImage source={source} onLoadEnd={doRedraw} />
        </View>
      </Marker>
    );
  },
);

export default CustomMarker;
